import React from "react";
// import HttpService from '../utils/Http.services';
import { siteConfig } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../components/Configurer";
// import Dashboard from "./profile/Dashboard";
import StagesManager from "../components/StagesManager";
import { checkPermission, checkTranslation, pathMaker, translate, imageAddress } from "../utils/useful";
// import EditProfile from "./profile/EditProfile";
import Cookies from "universal-cookie";
import PageStatusViewer from "../components/PageStatusViewer";
// import AccountType from "./profile/AccountType";
// import ChangePasword from "./profile/ChangePasword";
import AdminDashboard from "./admin/AdminDashboard";
import { adminWidgets } from "../variables/adminWidgets";

import AdminFormApplet from "./admin/AdminFormApplet";
import { adminPages } from "../variables/adminPages";
import Collapsible from "react-collapsible";
import Modal from "../components/Modal";
import CountriesModal from "../components/CountriesModal";
import AdminWidgetsPage from "./admin/AdminWidgetsPage";
import AdminPermission from "./admin/AdminPermission";
import HttpServices from '../utils/Http.services';
import AdminListApplet from "./admin/AdminListApplet";
import LoaderButton from "../components/LoaderButton";
import AdminListAppletRental from "./admin/AdminListAppletRental";
import { buildAdminMenuSections } from "../utils/adminMenuSequence";
// import Router from 'react-router-dom'

// import { logoutUser } from "../stores/actionsList";
const cookies = new Cookies();

class Admin extends React.Component {

    state = {
        showDropdownCountry: false,
        selectedCountry: {},
        countries: [],
        selectedCountries: [],

        isCountry: true,
        modules: [],
        collapses: {},
        pages: [
            { name: 'Dashboard', key: '', dontShowInDashboard: true },
            { name: 'Edit Profile', icon: 'https://www.flaticon.com/svg/static/icons/svg/2444/2444452.svg', key: 'edit' },
            { name: 'Account type', icon: 'https://www.flaticon.com/svg/static/icons/svg/744/744922.svg', key: 'type' },
            { name: 'Change Password', icon: 'https://www.flaticon.com/svg/static/icons/svg/3039/3039392.svg', key: 'password' },
        ]
    }


    componentDidMount() {
        // console.log('this.props.settings.country', this.props.settings)
        // console.log('didmoooo admins')
        this.fetchCountries()
        this.setState({
            isLoading: false,
            // selectedCountry: this.props.settings.country

        }, () => {
            this.checkDefaultTab()
            let accessPages = Object.values(adminPages)
            this.setState({ modules: accessPages })
        })

        // return

        const cookies = new Cookies();
        let token = cookies.get('admintoken');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }
    }
    fetchCountries = () => {
        this.setState({ isLoading: true })

        HttpServices.request('countriesGetAll', {}, (data, fetchError) => {
            if (fetchError) {
                console.log('errrrrrooooor')
                return this.setState({ fetchError, isLoading: false })
            }

            if (data) {
                data.info.sort((a, b) => {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                })
                data.info.sort((a, b) => {
                    if (a.priority < b.priority) {
                        return -1;
                    }
                    if (a.priority > b.priority) {
                        return 1;
                    }
                    return 0;
                })
                data.info.splice(0, 0, { name: "All" })
                this.setState({ countries: data.info, allCountries: data.info }, () => this.init())
            }
        })
    }
    init() {
        // console.log("init")
        // console.log(this.state.countries)
        // console.log(this.props.settings?.country)
        let selectedCountries = this.props.settings?.country ?? []
        // console.log('aaaaaaaaaaaaaaa',this.props.settings?.country)
        // console.log('hereeeeeeeeeeeeeeeee0')
        // return
        // if (this.state.countries && !(Array.isArray(selectedCountries) && selectedCountries.length > 0)) {
        //     // console.log('hereeeeeeeeeeeeeeeee')
        //     this.state.countries.forEach(element => {
        //         // console.log(element)
        //         if (element.name.toLowerCase() == 'singapore') {
        //             selectedCountries.push(element)
        //         }
        //     })
        //     // this.setCountry(country)
        //     // this.setState({ selectedCountry: country })
        //     if (Array.isArray(selectedCountries) && selectedCountries.length > 0) {
        //         this.setCountry()
        //     }
        // } else 
        if ((Array.isArray(selectedCountries) && selectedCountries.length > 0)) {
            // console.log('hereeeeeeeeeeee1eeeee')
            this.setState({ selectedCountries })
        } else {

            this.setState({ selectedCountries: [] })
            this.props.changeCountry('country', [])
        }
        // else if (this.state.countries && this.props.settings?.country) {
        //     console.log("init2222222")
        //     country = this.props.settings?.country

        // console.log(country)

        // }
    }

    // reload = () => {
    //     // window.location.reload(false);
    //     setTimeout(() => {
    //         Router.reload(window.location.pathname)
    //     }, 500);

    // }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {

            this.setState({ isLoading: false }, () => {
                this.checkDefaultTab()
                let accessPages = Object.values(adminPages)
                this.setState({ modules: accessPages })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    componentDidUpdate(newProps) {
        let windowPath = this.props.location.pathname.split('/')
        windowPath = windowPath[windowPath.length - 1]

        // console.log(this.state.oldPath)
        // console.log(this.props.location.pathname)
        if (this.state.oldPath != this.props.location.pathname) {
            this.setState({ oldPath: this.props.location.pathname }, () => {
                this.checkDefaultTab()
            })
        }
    }



    checkDefaultTab() {

        let def = ''
        let pageType = null
        let pageInfo = null
        let pathname = window.location.pathname.split('/')
        pathname.forEach((path, index) => {
            if (path == 'admin') {
                def = pathname[index + 1]
            }
        });

        // console.log(def)

        let pageIsValid = false

        Object.values(adminPages).forEach(page => {
            if (page.key.toLowerCase() === def?.toLowerCase()) {
                pageIsValid = true
                pageType = page.pageType
                // console.log(page)
                pageInfo = page
            }
        });

        // console.log("pageInfo")
        // console.log(checkPermission(pageInfo.permissionRules))
        if (!def || def == '' || checkPermission('admin.' + pageInfo.key) || (pageInfo.permissionRules && checkPermission(pageInfo.permissionRules))) {

            if (!def) {
                def = ''
            }
            // console.log(def)
            if (def === '') {
                pageType = ''
                pageIsValid = true
            }
            if (pageIsValid) {
                // this.state.page = page
                // console.log(page)
                this.setState({ oldPath: this.props.location.pathname, pageStatus: 200 }, () => {
                    this.setState({ path: def, }, () => {
                        this.stageManager.changeStage(pageType, () => {
                            window.scrollTo({ top: 0, behavior: 'smooth' })
                        })
                        setTimeout(() => {
                            this.setState({ page: null }, () => {

                                this.setState({ page: pageInfo })
                            })
                        }, 400);
                    })

                    // this.changePage(def)
                    // if (def == '' || !def) {
                    // this.stageManager.changeStage('dashboard')
                    // this.stageManager.changeStage(def)
                    // // this.props.history.push(pathMaker('/profile'))
                    // } else {

                    //     this.stageManager.changeStage(def)

                    // }
                })
            } else {
                this.setState({ pageStatus: 404 })
            }
        } else {
            this.setState({ pageStatus: 401 })
        }

    }



    changePage = (page) => {

        let path = pathMaker('/admin/' + page)

        this.props.history.push(path)

        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    changeCollapse = (key) => {
        this.setState((previousState) => ({
            collapses: {
                ...previousState.collapses,
                [key]: previousState.collapses[key] == null
                    ? true
                    : !previousState.collapses[key],
            },
        }))
    }
    toggleDropdownCountry() {
        // console.log('settings::::', this.props.settings)

        if (!this.state.showDropdownCountry) {
            document.addEventListener('mousedown', this.closeDropCountry);
            this.setState({ showDropdownCountry: true })
        } else {
            this.closeDropCountry()
        }
    }
    openSelectCountryModal() {
        // console.log('settings::::', this.props.settings)

        this.selectCountriescountriesModal.showModal()
    }

    closeDropCountry = (event) => {
        if (!event || (this.refs.dropdownCountry && !this.refs.dropdownCountry.contains(event.target) && this.state.showDropdownCountry)) {
            document.removeEventListener('mousedown', this.handleClickOutside);
            this.setState({ showDropdownCountry: false })
        }
    }
    selectCountry = (prop, selected) => {
        let selectedCountries = this.state.selectedCountries
        if (prop.name == "All") {
            selectedCountries = []

        }
        // if(countries.includes(prop))
        // console.log('this.props.item', this.props.settings?.country)
        // this.setState({ title: '' }, () => {
        //     // if (this.refs.input)
        //     //     this.refs.input.focus()
        // })


        if (selected) {
            if (selectedCountries.length > 1) {

                for (let i = 0; i < selectedCountries.length; i++) {

                    if (selectedCountries[i]._id == prop._id) {
                        selectedCountries.splice(i, 1)
                    }
                }
            }
        } else {
            if (prop.name != "All") {

                selectedCountries.push(prop)
            }
        }

        this.setState({ selectedCountries }, () => {
            // if (!dontChangeValue) this.changeValue()
        })
        // this.toggleDropdownCountry()

        // this.setState({ selectedCountry: prop })
    }
    setCountry = () => {
        // console.log('props :: ', prop)
        // console.log('settings::::', this.props.settings)
        let countries = this.state.selectedCountries
        this.props.changeCountry('country', countries)
        setTimeout(() => {
            window.location.reload();
        }, 100);
        // Router.reload(window.location.pathname)

    }


    showMenu() {
        const permittedModules = this.state.modules.filter(
            ({ key }) => checkPermission("admin" + '.' + key),
        );
        const menuSections = buildAdminMenuSections(permittedModules);

        return (
            <div>

                <div className="text-center py-3">
                    <img src="/images/male.png" width="70px" style={{ borderRadius: 100 }} />
                    <p className="font-bold mt-1">{this.props.user?.info?.name} {this.props.user?.info?.family}</p>
                    <p className="text-small">Admin</p>
                </div>

                {this.state.isCountry &&
                    <div className="flexcc" style={{ position: 'relative' }}>
                        <div style={{ textAlign: 'center' }}>

                            <div onClick={() => this.openSelectCountryModal()} className={''} style={{ cursor: 'pointer', borderRadius: 100, paddingRight: 10, background: '#677dc4', width: 'fit-content' }}>

                                {!Array.isArray(this.props.settings.country) ? (
                                    <div className="white px-3 py-2 text-bold text-small">
                                        <p>Is loading ...</p>
                                    </div>
                                ) : (
                                    <div className="row m-0">
                                        {Array.isArray(this.state.selectedCountries) && this.state.selectedCountries.map((prop, index) => {
                                            // console.log('prrrroopoppp',prop);
                                            return (
                                                <div className="row m-0 p-1">

                                                    {prop.icon ? (

                                                        <img width={'25px'} src={imageAddress(prop.icon)} style={{ borderRadius: '0', border: '1px solid #E6E6E6', borderRadius: 50 }} />
                                                    ) : (
                                                        <>
                                                            {prop.iso2 ? (

                                                                <img width={'20px'} src={`/images/flags/${prop.iso2.toLowerCase()}.svg`} alt={prop.emoji} />
                                                            ) : (<></>)}
                                                        </>
                                                    )

                                                    }
                                                </div>
                                            )
                                        })}
                                        {Array.isArray(this.state.selectedCountries) && this.state.selectedCountries.length == 0 && (
                                            <div className="row m-0">
                                                <p className="py-1 px-2" style={{ fontSize: 14, padding: 0, margin: 0, color: '#fff', marginLeft: 0, fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                                                    {/* <img src={imageAddress(this.state.selectedCountry.icon, null, 'thumb')} height={25} style={{ borderRadius: '40%', padding: '5px' }} /> */}
                                                    {/* <img src={imageAddress(this.props.settings.country?.icon)} height={30} style={{ borderRadius: '40%', padding: '5px', borderRadius: 40 }} /> */}
                                                    All
                                                    {/* <span>{prop?.iso3}</span> */}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        {this.state.showDropdownCountry && (
                            <div ref={"dropdownCountry"} className="" style={{ maxHeight: '500px', boxShadow: '0px 10px 15px #949494', overflow: 'scroll', position: 'absolute', backgroundColor: '#ffffffff', backdropFilter: 'saturate(180%) blur(10px)', WebkitBackdropFilter: 'saturate(180%) blur(10px)', zIndex: 999, borderRadius: '10px', top: 38, width: 190, padding: 0, }}>

                                <div className="scroll-no-scrollbar" style={{}}>
                                    <div style={{ padding: '0px 0px', width: '100%' }}>
                                        <p className="text-center py-2" style={{ fontWeight: 'bold', fontSize: 12, padding: '5px 10px', }}>SELECT COUNTRIES</p>
                                        {this.state.countries.map((prop, index) => {
                                            // if(prop.onlyFor == '0' || prop.onlyFor == null)
                                            return (
                                                <div className="lang-mnu" onClick={() => this.selectCountry(prop)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px #11223310 solid', cursor: 'pointer' }}>

                                                    <div className="lang-mnu" style={{ display: 'flex', alignItems: 'center', width: '100%', paddingLeft: '10px' }}>
                                                        <div style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center' }}>
                                                            {prop.icon ? (

                                                                <img width={'25px'} src={imageAddress(prop.icon)} style={{ borderRadius: '0', border: '1px solid #E6E6E6', borderRadius: 50 }} />
                                                            ) : (
                                                                <img width={'20px'} src={`/images/flags/${prop.iso2.toLowerCase()}.svg`} alt={prop.emoji} />

                                                            )}
                                                        </div>
                                                        <p style={{ fontSize: 14, padding: '10px 10px', }}>{prop.name}</p>
                                                    </div>
                                                    <div style={{ width: '30px', height: '30px', paddingRight: '10px' }}>

                                                        <img width={'20px'} src='/images/check2.png' alt='Check2' style={{ display: (this.props.settings.country?._id == prop._id) ? 'block' : 'none', }} />
                                                    </div>
                                                </div>
                                            )
                                        })}

                                    </div>
                                </div>

                            </div>
                        )}
                    </div>
                }

                <div className="mt-2">
                    <button onClick={() => this.changePage('')} className={"pageSideOption mainPage " + ('' == this.state.path ? "selected" : '')}>
                        <p>{translate('Admin Panel')}</p>
                    </button>

                    {menuSections.map((prop) => {
                        return (
                            <div key={prop.key} className="mt-0 pb-0" style={{ borderBottom: '1px solid #677dc420' }}>
                                <button type="button" aria-expanded={!this.state.collapses[prop.key]} className="admin-menu-primary-toggle flexcb w-100 py-2 m-0 px-0" style={{ backgroundColor: !this.state.collapses[prop.key] ? '#677dc410' : '#677dc420' }} onClick={() => this.changeCollapse(prop.key)}>
                                    <p className="admin-menu-primary-title text-smaller text-bold text-uppercase">{prop.name}</p>
                                    <p className="text-normal text-bold px-2" style={{ color: '#677dc470' }}>{!this.state.collapses[prop.key] ? "-" : "+"}</p>
                                </button>

                                <Collapsible open={!this.state.collapses[prop.key]}>
                                    {prop.subsections.map((subsection) => (
                                        <div key={subsection.key} className="pb-1">
                                            {siteConfig.showSmallHeaders && (
                                                <p
                                                    className="admin-menu-subsection-title text-smallest text-bold text-uppercase"
                                                >
                                                    {subsection.name}
                                                </p>
                                            )}
                                            {subsection.modules.map((cprop) => (
                                                <button
                                                    type="button"
                                                    onClick={() => this.changePage(cprop.key)}
                                                    key={cprop.key}
                                                    className={"admin-menu-item flexc pageSideOption " + (cprop.key == this.state.path ? "selected" : '')}
                                                >
                                                    <img alt="" className="mrd-3" src={cprop.image} style={{ borderRadius: 30, width: 30, height: 30, objectFit: 'cover' }} />
                                                    <p className="text-small " >{checkTranslation(cprop.title)}</p>
                                                </button>
                                            ))}
                                        </div>
                                    ))}
                                </Collapsible>
                            </div>
                        )
                    })}
                </div>

            </div>
        )
    }

    navigationBackButton(action) {
        return (
            <div className="flexc mx-2 h-100 d-md-none">
                <button className="p-0 m-0 flexcc h-100" onClick={() => this.mobileMenuModal.showModal()} style={{ backgroundColor: '#f2f6f8dd', color: '#334455', fontWeight: 'bold' }}>
                    <img className=" " src="/images/menu.png" alt="" width="30px" />
                </button>
                {/* <button onClick={() => this.props.nextStage()} style={{ backgroundColor: '#202020', color: '#fff', borderRadius: 30, padding: '5px 15px', fontWeight: 'bold' }}>NEXT</button> */}
            </div>
        )
    }

    informParent = (message) => {
        if (message == 'permissionDenied') {
            this.setState({ pageStatus: 401 })
        }
        if (message == 'notFound') {
            this.setState({ pageStatus: 404 })
        }
    }
    unicodeToEmoji = (unicodeString) => {
        if (unicodeString) {

            console.log('Original Unicode String:', unicodeString);
            const codePoints = unicodeString.split(' ').map(code => parseInt(code.replace('U+', ''), 16));
            console.log('Parsed Code Points:', codePoints);
            const emoji = String.fromCodePoint(...codePoints);
            console.log('Converted Emoji:', emoji);
            return emoji;
        }
    };
    search = async (value) => {

        // console.log(value)
        this.setState({ title: value })

        if (value == "") {
            await this.setState({ countries: this.state.allCountries })
            // await this.setState({ tempData: [] })
        } else {
            // if (this.state.tempData.length == 0) {
            //     await this.setState({ tempData: this.state.options })
            // }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            // console.log(this.state.tempData)
            this.state.allCountries.forEach(element => {
                if (String(element.name).toLowerCase().includes(String(value).toLowerCase()) || String(element.description).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })
            // console.log(values)

            this.setState({ countries: values })

            // }
        }
    }

    render() {
        let country = []
        let countries = this.props.settings.country ?? []
        for (let i = 0; i < countries.length; i++) {
            const element = countries[i];
            country.push(element.iso3)
        }
        let variables = {
            permissionRoot: 'admin.' + (this.state.page?.permissionParent ?? this.state.page?.key),
            country

        }
// console.log('vaaaaaaaaaaaaaar',variables);
        return (

            <Configurer
                settingsInfo={{
                    showFooter: true, showTabBar: true, showHeader: true, headerTitle: "Admin", button: {},
                    titleButtons: [this.navigationBackButton(this.props.lastStage)]
                }}
                title={"Admin"}
                description={"Admin Description"}
                className="p-0 min-full-height w-100"
                ref={el => this.configurer = el}
            >

                <PageStatusViewer status={this.state.pageStatus}>
                    <div className="w-100" >
                        <div className="row m-0">

                            <div className="col-12 col-sm-12 col-md-3 col-lg-2 pageSide px-0 d-md-block d-none" >
                                {this.showMenu()}
                            </div>


                            <Modal ref={el => this.mobileMenuModal = el} maxWidth={300}>
                                <div className="pageSide" style={{ backgroundColor: '#fff', borderRadius: 15, padding: '20px 5px 70px 5px' }}>
                                    {this.showMenu()}

                                </div>
                            </Modal>
                            <CountriesModal ref={el => this.selectCountriescountriesModal = el}>
                                <div className="h-100 w-100" style={{ height: '500px', boxShadow: '0px 10px 15px #949494', backgroundColor: '#ffffffff', backdropFilter: 'saturate(180%) blur(10px)', WebkitBackdropFilter: 'saturate(180%) blur(10px)', zIndex: 999, borderRadius: '10px', top: 38, width: 190, padding: 0, }}>
                                    <div className=" w-100" style={{ height: '450px', overflow: 'scroll', zIndex: 999, marginBottom: '5px' }}>
                                        <p className="text-center py-2" style={{ fontWeight: 'bold', fontSize: 12, padding: '5px 10px', }}>SELECT COUNTRIES</p>
                                        <div className="w-100 d-flex flexcc">

                                            <input onChange={event => this.search(event.target.value)} placeholder={translate("Search ...")} style={{ width: '280px', fontSize: 13, alignSelf: 'stratch', padding: 5, margin: 5, height: 35, backgroundColor: '#f7f7f7', borderRadius: 4, borderWidth: 1, borderStyle: 'solid', borderColor: '#eee', marginTop: 5 }} className={'text-start'} />
                                        </div>

                                        <div className="" style={{}}>
                                            <div style={{ padding: '0px 0px', width: '100%' }}>
                                                {this.state.countries.map((prop, index) => {

                                                    let selected = false
                                                    for (var i = 0; i < this.state.selectedCountries.length; i++) {

                                                        if (prop._id == this.state.selectedCountries[i]._id)
                                                            selected = true
                                                    }
                                                    return (
                                                        <div className="lang-mnu" onClick={() => this.selectCountry(prop, selected)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px #11223310 solid', cursor: 'pointer' }}>

                                                            <div className="lang-mnu" style={{ display: 'flex', alignItems: 'center', width: '100%', paddingLeft: '10px' }}>
                                                                {prop.name != "All" ? (
                                                                    <>
                                                                        <div style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center' }}>

                                                                            {prop.icon ? (

                                                                                <img width={'25px'} src={imageAddress(prop.icon)} style={{ borderRadius: '0', border: '1px solid #E6E6E6', borderRadius: 50 }} />
                                                                            ) : (
                                                                                <>
                                                                                    {prop.iso2 ? (

                                                                                        <img width={'20px'} src={`/images/flags/${prop.iso2.toLowerCase()}.svg`} alt={prop.emoji} />
                                                                                    ) : (<></>)}
                                                                                </>
                                                                            )

                                                                            }
                                                                        </div>
                                                                        {prop.pinned && (

                                                                            <img width={'20px'} src='/images/pin.png' />
                                                                        )}
                                                                        <p style={{ fontSize: 14, padding: '10px 10px', }}>{prop.name}</p>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center' }}>
                                                                            <img width={'25px'} src='/images/earth.png' />
                                                                        </div>
                                                                            <img className="" width={'20px'} src='/images/pin.png' />
                                                                        <p style={{ fontSize: 16, fontWeight: 600, padding: '10px 20px', }}>{prop.name}</p>
                                                                    </>

                                                                )}

                                                            </div>
                                                            <div style={{ width: '30px', height: '30px', paddingRight: '10px' }}>

                                                                <img width={'20px'} src='/images/check2.png' alt='Check2' style={{ display: (selected || (prop.name == "All" && Array.isArray(this.state.selectedCountries) && this.state.selectedCountries.length == 0)) ? 'block' : 'none', }} />
                                                            </div>
                                                        </div>
                                                    )

                                                })}
                                                {/* {this.state.countries.map((prop, index) => {
                                                    if (!prop.pinned && prop.name != 'All') {
                                                        let selected = false
                                                        for (var i = 0; i < this.state.selectedCountries.length; i++) {

                                                            if (prop._id == this.state.selectedCountries[i]._id)
                                                                selected = true
                                                        }
                                                        return (
                                                            <div className="lang-mnu" onClick={() => this.selectCountry(prop, selected)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px #11223310 solid', cursor: 'pointer' }}>

                                                                <div className="lang-mnu" style={{ display: 'flex', alignItems: 'center', width: '100%', paddingLeft: '10px' }}>
                                                                    <div style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center' }}>
                                                                        {prop.icon ? (

                                                                            <img width={'25px'} src={imageAddress(prop.icon)} style={{ borderRadius: '0', border: '1px solid #E6E6E6', borderRadius: 50 }} />
                                                                        ) : (
                                                                            <>
                                                                                {prop.iso2 ? (

                                                                                    <img width={'20px'} src={`/images/flags/${prop.iso2.toLowerCase()}.svg`} alt={prop.emoji} />
                                                                                ) : (<></>)}
                                                                            </>
                                                                        )

                                                                        }
                                                                    </div>
                                                                    <p style={{ fontSize: 14, padding: '10px 10px', }}>{prop.name}</p>
                                                                </div>
                                                                <div style={{ width: '30px', height: '30px', paddingRight: '10px' }}>

                                                                    <img width={'20px'} src='/images/check2.png' alt='Check2' style={{ display: selected ? 'block' : 'none', }} />
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })} */}

                                            </div>
                                        </div>

                                    </div>
                                    <LoaderButton
                                        onClick={() => this.setCountry()}
                                        isLoading={this.state.isApplyLoader}
                                        text={checkTranslation('{{lang}}apply')}
                                        type={"Oval"}
                                        className="flexc mx-1 flexcc"
                                        buttonStyle={{ height: 30, background: '#FAF8F8', borderRadius: 20, padding: '8px 15px', display: 'flex', alignItems: 'center', fontWeight: '550', textTransform: 'uppercase' }}
                                        width={40}
                                        height={40}
                                        color={'#FAF8F8'}
                                    />
                                </div>
                            </CountriesModal>



                            <div className="col-12 col-sm-12 col-md-9 col-lg-10 p-0" style={{}}>

                                <StagesManager ref={el => this.stageManager = el} >
                                    <AdminWidgetsPage variables={variables} pages={this.state.pages} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} title={"Admin Panel"} widgets={adminWidgets} description={"List of admin modules"} route={"admin"} />
                                    {/* <AdminDashboard pages={this.state.pages} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} title={"Admin Panel"} description={"List of admin modules"} route={"admin"} /> */}
                                    <AdminFormApplet page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} pages={adminPages} stageName={'form'} route={"admin"} />
                                    <AdminListApplet pages={this.state.pages} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'list'} route={"website"} variables={variables} />
                                    <AdminListAppletRental pages={this.state.pages} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'listRental'} route={"internationalRental"} variables={variables} />

                                    <AdminPermission pages={this.state.pages} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'permissions'} route={"admin"} />

                                </StagesManager>


                            </div>
                        </div>
                    </div>
                </PageStatusViewer>

            </Configurer>
        )
    }


}



const mapStateToProps = state => ({
    settings: state.settings,
    user: state.user,
    tickets: state.tickets
})
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    changeCountry: (name, value) => dispatch({ type: 'CHANGE_COUNTRY', name, value })
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Admin);
